import React from 'react';
import { Menu, MenuItem, Tooltip, IconButton, ListSubheader, Divider } from '@mui/material';
// import AppBarSearch from '../components/AppBarSearch';
// import BottomDrawer from '../components/BottomDrawer';
// import { AdvancedMarker } from '@vis.gl/react-google-maps';
import HistoryIcon from '@mui/icons-material/History';
import { LIVE_PRESET_RANGES, PRESET_RANGES } from '../../config';


function TimePresetMenuAndButton({ setTimeRange, presets, livePresets }: { setTimeRange: (range: [Date|string, Date|string]) => void, presets: { label: string; fromTime: string; toTime: string }[], livePresets: { label: string; fromTime: string; toTime: string }[] }) {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)

  const openMenu = (e: React.MouseEvent<HTMLElement>) => setAnchorEl(e.currentTarget)
  const closeMenu = () => setAnchorEl(null)

  return (
    <>
      <Tooltip title="Choose another time range" placement="top">
        <IconButton color="default" onClick={openMenu} sx={{ ml: 0 }}>
          <HistoryIcon />
        </IconButton>
      </Tooltip>
      {/* slotProps={{ paper: { elevation: 6 }}} */}
      <TimePresetMenu anchorEl={anchorEl} onClose={closeMenu} setTimeRange={setTimeRange} presets={presets} livePresets={livePresets} />
    </>
  )
}

export function TimePresetMenuAndIcon({ setTimeRange, presets, livePresets }: { setTimeRange: (range: [Date|string, Date|string]) => void, presets: { label: string; fromTime: string; toTime: string }[], livePresets: { label: string; fromTime: string; toTime: string }[] }) {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)

  const openMenu = (e: React.MouseEvent<HTMLElement>) => setAnchorEl(e.currentTarget)
  const closeMenu = () => setAnchorEl(null)

  return (
    <>
      <Tooltip title="Choose another time range" placement="top">
        <HistoryIcon onClick={openMenu} sx={{ fontSize: '1.2rem' }} />
      </Tooltip>
      {/* slotProps={{ paper: { elevation: 6 }}} */}
      <TimePresetMenu 
        anchorEl={anchorEl} 
        onClose={closeMenu} 
        setTimeRange={setTimeRange} 
        presets={presets} 
        livePresets={livePresets} 
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
      />
    </>
  )
}


export function TimePresetMenu({ setTimeRange, presets=PRESET_RANGES, livePresets=LIVE_PRESET_RANGES, anchorEl, onClose, ...props }: { 
    setTimeRange: (range: [Date|string, Date|string]) => void, 
    presets: { label: string; fromTime: string; toTime: string }[], 
    livePresets: { label: string; fromTime: string; toTime: string }[],
    anchorEl: HTMLElement | null;
    onClose: () => void;
  }) {
  return (
    <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={onClose} {...props}
      // sx={{ ...props.sx, maxHeight: '60vh', overflowY: 'auto' }}
      >
        <ListSubheader>Recent Data</ListSubheader>
        {livePresets.map((r) => (
            <MenuItem key={r.label} dense onClick={() => {
                setTimeRange([r.fromTime, r.toTime]);
                onClose();
            }}>
              {r.label}
            </MenuItem>
        ))}
        <Divider />
       <ListSubheader>Significant Events</ListSubheader>
      {presets.map((r) => (
        <MenuItem key={r.label} dense onClick={() => {
          setTimeRange([r.fromTime, r.toTime]);
          onClose();
        }}>
          {r.label}
        </MenuItem>
      ))}
    </Menu>
  )
}

export default React.memo(TimePresetMenuAndButton);